import { BasketCombinedSortType, useBasketListPaginated, useCurrentUi } from "@keepeek/commons";
import { BasketsEmptyState, withSuspense } from "@keepeek/refront-components";
import { Box, Skeleton } from "@mui/material";
import clsx from "clsx";
import { useRecoilValue } from "recoil";

import { configSectionComponentBasketSelector } from "../../../../providers/config/selectors";
import BasketCardForWidget from "./BasketCardForWidget";

const BasketsWidgetList = function ({
  widgetId,
  sort,
  size,
  page,
  queryFilter,
  setQueryFilter,
}: {
  widgetId: string;
  sort: BasketCombinedSortType;
  page: number;
  size: number;
  queryFilter: string;
  setQueryFilter: (q: string) => void;
}) {
  const { currentUi } = useCurrentUi();
  const { activateBasketPartitioning } = useRecoilValue(configSectionComponentBasketSelector) ?? {
    activateBasketPartitioning: false,
  };

  const { basketList } = useBasketListPaginated({
    sortParam: sort,
    pageParam: page,
    sizeParam: size,
    qParam: queryFilter,
    fqParam: activateBasketPartitioning ? [`uiId:${currentUi?.id}`] : [],
  });
  if (basketList.totalCount === 0) {
    return (
      <BasketsEmptyState hasFilters={queryFilter !== ""} resetFilters={() => setQueryFilter("")} />
    );
  }
  return (
    <Box
      component="ol"
      sx={{
        padding: 0,
        margin: 0,
        listStyle: "none",
        flexWrap: "wrap",
        alignItems: "strech",
        justifyContent: "center",
      }}
      display="flex"
      gap={2}
      className={clsx("BasketsWidget-basketsList")}
    >
      {basketList.baskets?.map((b) => (
        <Box
          component="li"
          key={b.id}
          sx={{ minWidth: (theme) => theme.spacing(40), maxWidth: "100%" }}
        >
          <BasketCardForWidget widgetId={widgetId} basket={b} />
        </Box>
      ))}
    </Box>
  );
};

const BasketsWidgetListLoading = function () {
  return (
    <Box
      component="ol"
      sx={{
        padding: 0,
        margin: 0,
        listStyle: "none",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
      }}
      display="flex"
      gap={2}
    >
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((_, i) => (
        <Box
          component="li"
          key={i}
          sx={{ minWidth: (theme) => theme.spacing(40), maxWidth: "100%" }}
        >
          <Skeleton height={"244px"} />
        </Box>
      ))}
    </Box>
  );
};

export default withSuspense(BasketsWidgetList, { LoadingComponent: BasketsWidgetListLoading });
